import { reactive } from 'vue';

export type ReportRoute = {
  type: string;
  name: string;
};

export type ReportUiState = {
  route: ReportRoute;
  showFilters: boolean;
  showSearch: boolean;
};

export const createReportModule = () => {
  const report = reactive<ReportUiState>({
    route: {
      type: '',
      name: '',
    },
    showFilters: false,
    showSearch: false,
  });

  const setReportRoute = (data: Partial<ReportRoute>) => {
    report.route = {
      type: data.type ?? '',
      name: data.name ?? '',
    };
  };

  const setShowFilters = (value: boolean) => {
    report.showFilters = value;
  };

  const setShowSearch = (value: boolean) => {
    report.showSearch = value;
  };

  const reset = () => {
    report.route = { type: '', name: '' };
    report.showFilters = false;
    report.showSearch = false;
  };

  return {
    state: {
      report,
      setReportRoute,
      setShowFilters,
      setShowSearch,
    },
    reset,
  };
};
